import { useColorMode as _useColorMode } from '@vueuse/core'

export function useColorMode() {
  return _useColorMode({
    selector: 'body',
    attribute: 'class',
    storageKey: 'facilityup-color-mode',
    initialValue: 'light',
    emitAuto: true,
  })
}
